import { render, staticRenderFns } from "./TopicGrid.vue?vue&type=template&id=765d3284&scoped=true"
import script from "./TopicGrid.vue?vue&type=script&lang=js"
export * from "./TopicGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765d3284",
  null
  
)

export default component.exports